export * from './StudyTabsEditModal.proptype';
export * from './StudyTabsEditModal';
